<template>
  <div class="display-flex flex-wrap pa1-mb mb1" :class="{ 'flex-column mt1 h30p': minimize}">
    <div class="display-flex justify-center align-center w100p" v-if="minimize && vitalsLength && vitals.length && !(vitalsLength - 10 <= vitals.length || vitals.length >= vitalsLength)">
        <span class="text-violet mr1">Please wait, Fetching latest data... </span>
        <bh-loader class="w2"/>
    </div>
    <bh-tab :tabs="tabs" @tabChange="onTabChange" v-if="!minimize" :activeTab="selectedTabIndex">
      <span class="display-flex justify-center align-center" v-if="vitalsLength && vitals.length && !(vitalsLength - 10 <= vitals.length || vitals.length >= vitalsLength)">
        <span class="text-violet mr1">Please wait, Fetching latest data... </span>
        <bh-loader class="w2"/>
      </span>
      <template v-if="selectedTabIndex === 0">
        <bh-vitals-chart-full-view
          :timeKey="timeKey"
          :timesData="timesData"
          :optionsData="optionsData"
          :primaryModel="primaryModel"
          :isInvalidCustomDate="isInvalidCustomDate"
          :dateRange="dateRange"
          @onBrushEnd="onBrushEnd"
          @syncZoom="syncZoom"
          @chartClicked="chartClicked"
          @onTimeRange="onTimeRange"
          @onCustomDatePick="onCustomDatePick"
          @clearError="clearError"
          @onResetVital="onResetVital"
        />
      </template>
      <template v-if="selectedTabIndex === 1">
        <bh-vitals-chart-detailed-view
          :timeKey="timeKey"
          :timesData="timesData"
          :optionsData="optionsData"
          :chartName="chartName"
          :primaryModel="primaryModel"
          :isInvalidCustomDate="isInvalidCustomDate"
          :dateRange="dateRange"
          @syncZoom="syncZoom"
          @onBrushEnd="onBrushEnd"
          @chartClicked="chartClicked"
          @onTimeRange="onTimeRange"
          @onCustomDatePick="onCustomDatePick"
          @clearError="clearError"
          @onResetVital="onResetVital"
        />
      </template>
    </bh-tab>
    <template v-else>
      <bh-vitals-chart-detailed-view
        minimize
        :timeKey="timeKey"
        :timesData="timesData"
        :optionsData="optionsData"
        :chartName="chartName"
        :primaryModel="primaryModel"
        :isInvalidCustomDate="isInvalidCustomDate"
        :dateRange="dateRange"
        @syncZoom="syncZoom"
        @onBrushEnd="onBrushEnd"
        @chartClicked="chartClicked"
        @onTimeRange="onTimeRange"
        @onCustomDatePick="onCustomDatePick"
        @clearError="clearError"
        @onResetVital="onResetVital"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import DetailedView from './DetailedView'
import FullView from './FullView'
import { prepareData, prepareTemperatureOptions, prepareButaneOptions, prepareSulphurDioxideOptions, prepareCarbonDioxideOptions, optionsData, getBrushCoordinates } from '@/services/device-options'
import { timesData } from '@/services/device-details'

export default {
  name: 'bh-vitals-chart',
  components: {
    'bh-vitals-chart-detailed-view': DetailedView,
    'bh-vitals-chart-full-view': FullView
  },
  props: {
    minimize: {
      type: Boolean,
      default: false
    },
    alertId: {
      type: String
    },
    chartName: {
      type: String,
      default: 'chartDetail'
    },
    primaryModel: {
      type: String
    },
    isFeedback: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      timeKey: 'All',
      timesData,
      currentTab: 'full-view',
      tabs: [
        {
          name: 'Full View',
          key: 'full-view'
        },
        {
          name: 'Detailed View',
          key: 'detailed-view'
        }
      ],
      tabOptions: {},
      optionsData: {
        temperature: {},
        butane: {},
        sulphurDioxide: {},
        carbonDioxide: {}

      },
      isInvalidCustomDate: false,
      interval: 2,
      dateRange: {}
    }
  },
  computed: {
    ...mapGetters('device', ['device', 'vitals', 'submittedFeedbacks', 'unSubmittedFeedbacks', 'customDateRange', 'vitalsLength', 'selectedTabIndex']),
    isFullView() {
      if (this.isFeedback || this.selectedTabIndex) {
        return false
      }
      return this.currentTab === 'full-view'
    }
  },
  beforeMount() {
    // this.prepareOptions(this.vitals)
    this.$root.$on('addedNewAlert', () => {
      this.prepareOptionsData()
    })
  },
  watch: {
    vitals(newVal, oldVal) {
      if (newVal && newVal.length === this.interval) {
        this.interval = this.interval + 200
        this.prepareOptions(this.vitals)
      } else if (this.interval > 200 && this.vitals && this.vitalsLength && this.vitals.length === this.vitalsLength) {
        this.prepareOptions(this.vitals)
        this.interval = 200
      }
    }
  },
  async mounted() {
    if (!this.vitalsLength || this.vitals.length === this.vitalsLength) {
      this.dateRange = await this.getMinMaxDate()
    }
  },
  methods: {
    // error change
    ...mapActions('device', ['setBrushCoords', 'setSingleProperty', 'getMinMaxDate']),
    onTabChange(e) {
      this.setSingleProperty(['selectedTabIndex', e])
      this.currentTab = this.tabs[e]?.key
      this.prepareOptionsData()
    },
    onBrushEnd({ event, refs }) {
      const coordRange = event?.areas?.[0]?.coordRange
      if (coordRange?.length) {
        const brush = {
          type: 'brush',
          areas: [
            {
              brushType: 'lineX',
              xAxisIndex: 0,
              coordRange
            }
          ]
        }
        refs?.temperature?.$refs?.chart?.dispatchAction(brush)
        refs?.butane?.$refs?.chart?.dispatchAction(brush)
        refs?.sulphurDioxide?.$refs?.chart?.dispatchAction(brush)
        refs?.carbonDioxide?.$refs?.chart?.dispatchAction(brush)
        refs?.chartRef?.$refs?.chart?.dispatchAction(brush)
        this.$emit('brushEnd', {
          startTime: optionsData.xAxisData[coordRange[0]],
          endTime: optionsData.xAxisData[coordRange[1]]
        })
        this.syncZoom({ event: { start: coordRange[0], end: coordRange[1] }, refs })
      }
    },
    syncZoom({ event, refs }) {
      const zoom = {
        type: 'dataZoom',
        start: event.start,
        end: event.end === 1 || event.end > 100 ? 100 : event.end
      }
      refs?.temperature?.$refs?.chart?.dispatchAction(zoom)
      refs?.butane?.$refs?.chart?.dispatchAction(zoom)
      refs?.carbonDioxide?.$refs?.chart?.dispatchAction(zoom)
    },
    prepareOptionsData() {
      const { isFullView, minimize } = this
      this.optionsData['temperature'] = prepareTemperatureOptions({ isFullView, minimize })
      this.optionsData['butane'] = prepareButaneOptions({ isFullView, minimize })
      this.optionsData['sulphurDioxide'] = prepareSulphurDioxideOptions({ isFullView, minimize })
      this.optionsData['carbonDioxide'] = prepareCarbonDioxideOptions({ isFullView, minimize })
    },
    async prepareOptions(vitals = []) {
      if (vitals.length) {
        const { minimize, alertId, submittedFeedbacks, unSubmittedFeedbacks } = this
        prepareData({ vitals, minimize, alertId, submittedFeedbacks, unSubmittedFeedbacks })
        this.prepareOptionsData()
        this.onTimeRange({ time: timesData['All'], key: 'All' })
        if (this.vitals.length === this.vitalsLength) {
          const brushCoords = getBrushCoordinates({ vitals, unSubmittedFeedbacks })
          this.setBrushCoords(brushCoords)
          this.dateRange = await this.getMinMaxDate()
        }
      }
    },
    onTimeRange({ time, key, selectedTab, refs }) {
      this.timeKey = key
      const tabData = this.optionsData[selectedTab]
      let start = 0
      const end = 100
      if (time.ms) {
        const xAxisData = tabData?.xAxis?.data
        const totalTime = new Date(xAxisData[xAxisData?.length - 1]).getTime() - new Date(xAxisData[0]).getTime()
        start = 100 - ((time.ms / totalTime) * 100)
      }
      if (tabData?.dataZoom?.length) {
        tabData.dataZoom[0].start = start
        tabData.dataZoom[0].end = end
        if (refs) {
          this.syncZoom({ event: { start, end }, refs })
        }
      }
    },
    chartClicked(ev) {
      const brushClear = {
        type: 'brush',
        areas: []
      }
      /* eslint-disable */
      this.$refs?.temperature?.$refs?.chart?.dispatchAction(brushClear)
      this.$refs?.butane?.$refs?.chart?.dispatchAction(brushClear)
      this.$refs?.sulphurDioxide?.$refs?.chart?.dispatchAction(brushClear)
      this.$refs?.carbonDioxide?.$refs?.chart?.dispatchAction(brushClear)

      if (ev.componentType === 'markArea') {
        this.$emit('areaClicked', ev?.value)
      } else if (ev.componentSubType === 'scatter' || ev.componentSubType === 'effectScatter' || ev.componentSubType === 'line') {
        this.$emit('brushEnd', {
          startTime: ev?.value[0],
          endTime: ev?.value[0]
        })
        if (ev?.value[2]?.feedback) {
          this.$emit('areaClicked', ev?.value[2].feedback)
        }
      }
    },
    onCustomDatePick({ startTime, endTime, selectedTab }) {
      const tabData = this.optionsData[selectedTab]
      const xAxisData = tabData?.xAxis?.data
      const latestVitalDate = this.customDateRange.maxDate
      const firstVitalDate = this.customDateRange.minDate
      let selectedDate = (startTime) / 1000

      if (selectedDate < firstVitalDate) {
        const startDate = new Date(firstVitalDate * 1000)
        selectedDate = firstVitalDate
        startTime = firstVitalDate * 1000
        endTime = new Date(new Date(startDate).setHours(new Date(startDate).getHours() + 2)).getTime()
      }

      if (selectedDate > latestVitalDate) {
        const startDate = new Date(latestVitalDate * 1000)
        selectedDate = latestVitalDate
        startTime = new Date(new Date(startDate).setHours(new Date(startDate).getHours() - 2)).getTime()
        endTime = latestVitalDate * 1000
      }

      this.isInvalidCustomDate = !(selectedDate >= firstVitalDate && selectedDate <= latestVitalDate)
      this.setSingleProperty(['customDateSet', !this.isInvalidCustomDate])
      this.$emit('onCustomDateSelect', { startTime, endTime, isInvalidDate: this.isInvalidCustomDate })
    },
    clearError() {
      this.isInvalidCustomDate = false
      this.setSingleProperty(['customDateSet', false])
    },
    onResetVital() {
      this.$emit('onResetVital', true)
    }
  }
}
</script>
